<div class="store-sales-performance-container container" fxLayout="column" fxLayoutGap="30px"
     [ngClass]="{'default-padding': !hasStandardLicense}">
  <h1 class="mat-h1 color-primary text-small-caps no-bottom-margin">Sales Performance Insights</h1>
  <hr/>
  <div fxLayout="column" fxLayoutGap="30px" *ngIf="store.isActive() && volume; else missingAllData">

    <div fxLayout="column" fxLayoutGap="15px" *ngIf="selectedComparisons.length > 0; else missingData">
      <!-- GRO-713/715: absolute-rank rings (two comparison groups) replace the percentile cards -->
      <div class="rank-rings-subtitle">
        Click any ring to open the Comprehensive Ranking table
      </div>

      <!-- GRO-713: loader shown while the ranking data is being fetched -->
      <div class="rank-rings-loading" *ngIf="ringsLoading">
        <span class="rank-rings-spinner" aria-hidden="true"></span>
        <span class="rank-rings-loading-text">Loading rankings…</span>
      </div>

      <div class="rank-ring-groups" *ngIf="!ringsLoading">
        <div class="rank-ring-group" *ngFor="let group of rankGroups">
          <div class="rank-ring-group-header" (click)="onShowComprehensiveRanking(group.autoOpenDetail)">
            <span class="rank-ring-group-title" [style.color]="group.accent">{{ group.title }}</span>
            <button type="button" class="rank-ring-open" [style.color]="group.accent"
                    aria-label="Open Comprehensive Ranking in a new tab"
                    (click)="onShowComprehensiveRanking(group.autoOpenDetail); $event.stopPropagation()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M7 17L17 7M8 7h9v9"/>
              </svg>
            </button>
          </div>
          <div class="rank-ring-divider"></div>
          <div class="rank-ring-row">
            <div class="rank-ring" *ngFor="let r of group.rings" (click)="onShowComprehensiveRanking(group.autoOpenDetail)">
              <div class="rank-ring-dial">
                <svg class="rank-ring-svg" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,.08)" stroke-width="9"/>
                  <circle cx="50" cy="50" r="42" fill="none" [attr.stroke]="r.color" stroke-width="9"
                          [attr.stroke-dasharray]="r.dash" stroke-linecap="round"/>
                </svg>
                <div class="rank-ring-center">
                  <div class="rank-ring-rank">{{ r.rank != null ? r.rank : 'N/A' }}</div>
                  <div class="rank-ring-total" *ngIf="r.total != null">of {{ r.total }}</div>
                </div>
              </div>
              <div class="rank-ring-label">{{ r.label }}</div>
            </div>
          </div>
        </div>
      </div>

</div>


  <!-- Store Ranking Filters and Chart -->
  <div fxLayout="column" fxLayoutGap="30px">
    <!-- GRO-714: Ranking filters + metric toggle share one row -->
    <div class="ranking-filters-bar" fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="15px">
      <mtn-store-ranking-filters class="ranking-filters-flex"
        [keyIndicator]="comparisonTypeForm.get('keyIndicator')?.value"
        (filtersChanged)="onRankingFiltersChanged($event)">
      </mtn-store-ranking-filters>
      <div class="key-indicator-toggle" role="group" aria-label="Comparing by metric">
        <button type="button" class="toggle-option"
                [class.active]="comparisonTypeForm.get('keyIndicator')?.value === KeyIndicatorType.SALES_VOLUME"
                (click)="selectKeyIndicator(KeyIndicatorType.SALES_VOLUME)">
          Estimated Sales
        </button>
        <button type="button" class="toggle-option"
                [class.active]="comparisonTypeForm.get('keyIndicator')?.value === KeyIndicatorType.SALES_SQFT"
                (click)="selectKeyIndicator(KeyIndicatorType.SALES_SQFT)">
          Est. Sales / PSF
        </button>
      </div>
    </div>
    <mtn-store-ranking-scatter-chart
      [comparisonType]="currentComparisonType"
      [keyIndicator]="comparisonTypeForm.get('keyIndicator')?.value"
      [currentStoreUuid]="store?.uuid"
      [filters]="currentRankingFilters"
      (rankingDataUpdated)="onRankingDataUpdated($event)">
    </mtn-store-ranking-scatter-chart>

    <!-- Chart Legend -->
    <div class="chart-legend">
      <div class="legend-item">
        <svg class="legend-circle" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6.5" cy="6.5" r="5.716" fill="#26C066" stroke="white" stroke-width="0.762"/>
        </svg>
        <span class="legend-label">Your store</span>
      </div>

      <div class="legend-item">
        <svg class="legend-circle" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6.5" cy="6.5" r="5.716" fill="#3E82DA" stroke="white" stroke-width="0.762"/>
        </svg>
        <span class="legend-label">Same banner</span>
      </div>

      <div class="legend-item">
        <svg class="legend-circle" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6.5" cy="6.5" r="5.716" fill="#F4742F" stroke="white" stroke-width="0.762"/>
        </svg>
        <span class="legend-label">7 min Competitor</span>
      </div>

      <div class="legend-item">
        <svg class="legend-circle" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="6.5" cy="6.5" r="5.716" fill="#6C7380" stroke="white" stroke-width="0.762"/>
        </svg>
        <span class="legend-label">CBSA/MSA Competitor</span>
      </div>
    </div>

    <!-- Comprehensive Ranking Button -->
    <div class="comprehensive-ranking-button-container" fxLayoutAlign="center center">
      <button class="comprehensive-ranking-button" (click)="onShowComprehensiveRanking()">
        <span>Show Comprehensive Ranking</span>
      </button>
    </div>
  </div>
  </div>
  <mtn-restricted-license-overlay *ngIf="!hasStandardLicense"></mtn-restricted-license-overlay>
</div>

<ng-template #missingAllData>
  <div class="missing-all-data-row" fxLayoutAlign="center center">
    <span class="color-muted">{{Dictionary.labelStoreMissingRequiredData}}</span>
  </div>
</ng-template>

<ng-template #missingData>
  <div class="missing-data-row" fxLayoutAlign="center center">
    <span class="color-muted">{{Dictionary.labelStoreMissingRequiredData}}</span>
  </div>
</ng-template>
